import Vue from 'vue'

function registerAll(context_module) {
  context_module.keys().map(key => {
    const name = key.match(/\w+/)[0];
    return Vue.component(name, context_module(key).default)
  });
}
registerAll(require.context('./layout/', true, /\.vue$/));
registerAll(require.context('./shared/', true, /\.vue$/));
registerAll(require.context('./pages/homepage/shared/', true, /\.vue$/));



// WEBPACK FOOTER //
// ./src/components/global.js